import { Routes, Route, BrowserRouter, NavLink } from 'react-router-dom';
import type { ReactElement } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import HomePageContainer from './home/home-page-container';
import MembersRouter from './members/members-router';
import TourHistoryRouter from './tour-history/tour-history-router';
import FormatStatsPageContainer from './format-stats/format-stats-page-container';
import HeadToHeadContainer from './head-to-head/head-to-head-container';
import CaptaincyStatsContainer from './captaincy/captaincy-stats-container';
import RyderCupMemberStatsContainer from './ryder-cup-stats/ryder-cup-member-stats-container';
import OtherCompPageContainer from './other-comps/other-comp-page';
import GalleryPage from './gallery/gallery-page';
import AboutPageContainer from './about/about-page-container';
import NotFound from './not-found';
import RouteErrorBoundary from './common/route-error-boundary';

import './styles.css';

// Navigation component
const AppNavigation = () => (
  <Navbar expand="md" className="bg-body-tertiary" style={{ padding: 0 }}>
    <Navbar.Brand>
      <NavLink to="/" id="ColinNavLink">
        <img
          src="/assets/Crazy English Logo - Grey.svg"
          className="d-inline-block align-top"
          height="48px"
          alt="Crazy English"
        />
      </NavLink>
    </Navbar.Brand>
    <Navbar.Toggle />
    <Navbar.Collapse>
      <Nav>
        <Nav.Link as={NavLink} to="/" end>
          Home
        </Nav.Link>
        <Nav.Link as={NavLink} to="/members">
          Members
        </Nav.Link>
        <Nav.Link as={NavLink} to="/summer-tour">
          Summer Tour
        </Nav.Link>
        <NavDropdown title="Ryd-Her Cup" id="ryd-her-cup-dropdown">
          <NavDropdown.Item as={NavLink} to="/format-stats">
            Format Stats
          </NavDropdown.Item>
          <NavDropdown.Item as={NavLink} to="/head-2-head">
            Head 2 Head
          </NavDropdown.Item>
          <NavDropdown.Item as={NavLink} to="/captaincy">
            Captaincy
          </NavDropdown.Item>
          <NavDropdown.Item as={NavLink} to="/member-stats">
            Member Stats
          </NavDropdown.Item>
        </NavDropdown>
        <Nav.Link as={NavLink} to="/other-comps">
          Other Comps
        </Nav.Link>
        <Nav.Link as={NavLink} to="/gallery">
          Gallery
        </Nav.Link>
        <Nav.Link as={NavLink} to="/about">
          About
        </Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);

// Helper to wrap components in error boundary
const withErrorBoundary = (Component: ReactElement) => <RouteErrorBoundary>{Component}</RouteErrorBoundary>;

// Ryder Cup related routes
const RyderCupRoutes = () => (
  <>
    <Route path="/format-stats" element={withErrorBoundary(<FormatStatsPageContainer />)} />
    <Route path="/head-2-head" element={withErrorBoundary(<HeadToHeadContainer />)} />
    <Route path="/captaincy" element={withErrorBoundary(<CaptaincyStatsContainer />)} />
    <Route path="/member-stats" element={withErrorBoundary(<RyderCupMemberStatsContainer />)} />
  </>
);

// Application routes component
const AppRoutes = () => (
  <Routes>
    <Route index element={withErrorBoundary(<HomePageContainer />)} />
    <Route path="/members/*" element={withErrorBoundary(<MembersRouter />)} />
    <Route path="/summer-tour/*" element={withErrorBoundary(<TourHistoryRouter />)} />
    {RyderCupRoutes()}
    <Route path="/other-comps/*" element={withErrorBoundary(<OtherCompPageContainer />)} />
    <Route path="/gallery" element={withErrorBoundary(<GalleryPage />)} />
    <Route path="/about/*" element={withErrorBoundary(<AboutPageContainer />)} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => (
  <BrowserRouter>
    <div>
      <AppNavigation />
      <AppRoutes />
    </div>
  </BrowserRouter>
);

export default App;
